<app-navbar-hof></app-navbar-hof>
<main
    class="min-h-screen ~space-y-8/24 rendererWrapper"
    (click)="cartService.closeCart()"
>
    <ng-container #viewContainerRef></ng-container>
</main>
<app-footer-hof></app-footer-hof>
